import React from 'react';
import ReactDOM from 'react-dom/client';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';
import App from './App';
import './assets/styles/index.css';
import { initSentry } from './config/sentry';
import { log } from './utils/protokoll';
import { einmalNeuLaden, istChunkLadefehler } from './utils/chunkFehler';

// Muss vor jedem log.warn/log.error stehen, das dokumentiert werden soll
// -- siehe config/sentry.ts. Ohne VITE_SENTRY_DSN ein No-op.
initSentry();

/*
 * Fehler ausserhalb von React: Ereignisbehandler und asynchroner Code
 * laufen an der Fehlergrenze (components/Fehlergrenze.tsx) vorbei --
 * die faengt nur Renderfehler ab. Ohne diese beiden Haken bliebe genau
 * die Klasse Fehler undokumentiert, die am haeufigsten vorkommt: eine
 * abgelehnte Promise in einem Klick-Handler, die niemand behandelt hat.
 */
// Nach einem Deployment fehlen die alten Chunk-Dateien: neu laden statt
// den Benutzer mit einem Fehler zu belassen (utils/chunkFehler.ts).
window.addEventListener('vite:preloadError', (ereignis) => {
  ereignis.preventDefault();
  if (!einmalNeuLaden()) log.warn('Chunk konnte nicht geladen werden', ereignis);
});
window.addEventListener('error', (ereignis) => {
  if (istChunkLadefehler(ereignis.error ?? ereignis.message) && einmalNeuLaden()) return;
  log.error('Unbehandelter Fehler', ereignis.error ?? ereignis.message);
});
window.addEventListener('unhandledrejection', (ereignis) => {
  if (istChunkLadefehler(ereignis.reason) && einmalNeuLaden()) return;
  log.error('Unbehandelte Ablehnung eines Versprechens', ereignis.reason);
});

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 1000 * 60 * 5, // 5 minutes
      refetchOnWindowFocus: false,
    },
  },
});

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <App />
      <ReactQueryDevtools initialIsOpen={false} />
    </QueryClientProvider>
  </React.StrictMode>
);
